import { handleActions } from 'redux-actions';

import { increment, decrement } from 'shared/redux/helpers/counter';

import { NAMES as SERVER_CHANNELS_LIST } from 'shared/redux/server/actions/channels/list';
import { NAMES as SERVER_CHANNELS_SEARCH } from 'shared/redux/server/actions/channels/search';


export default handleActions({
  [SERVER_CHANNELS_LIST.START]: increment,
  [SERVER_CHANNELS_SEARCH.START]: increment,

  [SERVER_CHANNELS_LIST.SUCCESS]: decrement,
  [SERVER_CHANNELS_SEARCH.SUCCESS]: decrement,

  [SERVER_CHANNELS_LIST.FAIL]: decrement,
  [SERVER_CHANNELS_SEARCH.FAIL]: decrement,
}, 0);



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/channels/active-requests.js